module.exports = __webpack_public_path__ + "img/menu-xc.8f542f42.png";